import { JobStatus } from '@common-packages/shared-constants';

export const isJobInProgress = status =>
  status === JobStatus.WAITING || status === JobStatus.PROCESSING;
